<!--
 * @Description: 日程会场列表页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-06-23 12:25:55
 * @LastEditors: 山淑兰
 -->
<template>
    <div class="roomlist">
        <div class="loading-wrap" v-if="loading">
            <div class="loading-pulse"></div>
            <p>加载中...</p>
        </div>
        <div class="guest-con">
            <div class="letter-group" v-for="(item,index) in pinYinList" :key="index" :ref="`pinyin${index}`">
                <div class="letter-header">
                    <span class="letter-char">{{item}}</span>
                    <span class="letter-line"></span>
                </div>
                <template v-if="$i18n.locale === 'zh-CN'">
                    <div class="guest-card" :id="'guest-'+ index" v-for="(items,indexs) in expertList[item]" :key="indexs" @click="godetail(items.exid)">
                        <div class="card-accent"></div>
                        <div class="guest-photo">
                            <img :src="items.photo || this.defaultHeadImg" alt />
                        </div>
                        <div class="guest-info">
                            <div class="guest-cname" v-html="nToBr(items.cname)"></div>
                            <div class="guest-cncompany" v-html="nToBr(items.cncompany)"></div>
                            <div class="guest-cnintroduction" v-if="introShow">
                                {{items.cnintroduction}}
                                <span class="detail-link">查看详情</span>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="guest-card" :id="'guest-'+ index" v-for="(items,indexs) in expertList[item]" :key="indexs" @click="godetail(items.exid)">
                        <div class="card-accent"></div>
                        <div class="guest-photo">
                            <img :src="items.photo || this.defaultHeadImg" alt />
                        </div>
                        <div class="guest-info">
                            <div class="guest-cname" v-html="items.enname!=null&&items.enname!=''?nToBr(items.enname):nToBr(items.cname)"></div>
                            <div class="guest-cncompany" v-html="items.encompany!=null&&items.encompany!=''?nToBr(items.encompany):nToBr(items.cncompany)"></div>
                            <div class="guest-cnintroduction" v-if="introShow">
                                {{items.enintroduction!=null&&items.enintroduction!=''?items.enintroduction:items.cnintroduction}}
                                <span class="detail-link">more</span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="guset-nav" :class="{fixed: fixed}">
                <div
                    class="letter-t"
                    v-for="(item,index) in pinYinList"
                    :key="index"
                    :class="{active: activeBtn==index}"
                    @click="goGuest('#guest-'+index,index)"
                >{{item}}</div>
            </div>
        </div>
        <div class="modal" v-if="modalShow">
            <div class="details-conss">
                <DetailsNews :exid="exid" :introStatus="introShow" @func="closeGuest" />
            </div>
        </div>
    </div>
</template>
<script>
    import defaultHeadImg from '../../../assets/defaultHeadImg.png'
import DetailsNews from './detail.vue';
export default {
    name: 'place',
	props: ['introShow'],
    components: {
        DetailsNews
    },
    data() {
        return {
            loading: false,
            loading1: false,
            pinYinList: [],
            expertList: [],
            m: '',
            dateid: 0,
            roomid: 0,
			rid: 0,
            search: '',
            defaultHeadImg,
            modalShow: false,
            exid: '',
            fixed: false,
            activeBtn: -1,
            fixedLetter: '',
        }
    },
    watch: {
        $route(to, from) {
            if (to.query.dateid != from.query.dateid && to.query.dateid) {
                this.dateid = to.query.dateid
                this.init()
            }
        },
        // 弹窗打开时锁定页面滚动，防止安卓机型滚动时弹窗底部漂移
        modalShow(val) {
            const overflow = val ? 'hidden' : ''
            document.body.style.overflow = overflow
            document.documentElement.style.overflow = overflow
        },
    },
    created() {
        if (this.$route.query) {
            this.dateid = this.$route.query.dateid
            this.init()
        }
        this.fixed = false
        document.addEventListener('scroll', this.handleScroll, true)
    },
    beforeDestroy () {
        document.removeEventListener('scroll', this.handleScroll, true);
    },
    methods: {
        handleScroll(){
            //var a = document.getElementsByClassName('guest-con')[0].offsetHeight;
            let that = this
            // let i = 1
            // console.log(that.$refs[`pinyin${i}`][0].getBoundingClientRect().top)
            this.$nextTick(() => {    
                for( let i in that.pinYinList ){
                    let pinyinHeight = that.$refs[`pinyin${i}`][0].getBoundingClientRect().top
                    if( pinyinHeight <= 20 ){
                        that.activeBtn = i
                    }
                }
            })
            
            if( window.pageYOffset >= 206 ){
                this.fixed = true
            }else{
                this.fixed = false
                that.activeBtn = -1
            }
        },
        goGuest(selector, index) {
            this.activeBtn = index;
			console.log(selector)
            this.$el.querySelector(selector).scrollIntoView()
        },
        async init() {
            try {
                this.loading = true
                const {
                    m,
                    dateid = this.dateid,
                    roomid = this.roomid,
                    search = this.search,
                } = this.$route.query //获得路由的参数
                this.m = m

                const _params = {
                    m: this.m
                }
                const res = await this.$http.getProDateRoom(_params)
                this.$emit('searchDatas', res.childens)
                console.log(res.childens)

                this.guestList()

                this.loading = false
            } catch (error) {
                console.error(error)
            }

            // this.$toast.clear(false); //关闭加载动画
        },

        async guestList(){
            try {
                const {
                    m,
                    roomid = this.roomid,
                    search = this.search,
					rid = this.rid,
                } = this.$route.query //获得路由的参数
                this.m = m
                const _params = Object.assign({ m, roomid, rid },
                    search ? { search } : {}
                ) //search 是空字符串 为false 有值是true

                const res = await this.$http.getExpertProList(_params)
                console.log(res)
                this.expertList = res.ExpertList
                this.pinYinList = res.PinYinList
                if (this.pinYinList.includes('#') && (!this.expertList['#'] || this.expertList['#'].length === 0)) {
                    this.pinYinList = this.pinYinList.filter(item => item !== '#')
                }
            } catch (error) {
                console.error(error)
            }
        },

        godetail(id) {
            this.exid = id
            this.modalShow = true
        },
        closeGuest(){
          this.modalShow = false
        },
        nToBr (str){
            if( str ){
                return str.replace(/\\n/g,'<br/>');
            }else{
                return str
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.roomlist {
    --ink: #2c2c3a;
    --ink-light: #5a5a6e;
    --ink-muted: #8e8e9e;
    --accent: #2563eb;
    --accent-soft: #60a5fa;
    --bg: #f5f8fb;
    --card-bg: #ffffff;
    --border: #e2e8f0;
    --border-light: #f1f5f9;
    --shadow-sm: 0 2px 8px rgba(44, 44, 58, 0.04);
    --shadow-md: 0 4px 16px rgba(44, 44, 58, 0.06);
    --radius: 16px;

    min-height: 100vh;
    margin-bottom: 80px;
    font-size: 26px;
    line-height: 1.6;
    background: var(--bg);
    color: var(--ink);
}

.loading-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60vh;
    gap: 24px;
    color: var(--ink-muted);
    font-size: 26px;
}

.loading-pulse {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: var(--accent);
    opacity: 0.4;
    animation: pulse-ring 1.2s ease infinite;
}

@keyframes pulse-ring {
    0% { box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.4); }
    70% { box-shadow: 0 0 0 24px rgba(37, 99, 235, 0); }
    100% { box-shadow: 0 0 0 0 rgba(37, 99, 235, 0); }
}

.guest-con {
    position: relative;
    padding: 12px 52px 20px 16px;
}

.letter-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 8px 10px;
}

.letter-char {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: var(--accent);
    color: #fff;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 1px;
    flex-shrink: 0;
}

.letter-line {
    flex: 1;
    height: 1px;
    background: linear-gradient(to right, var(--border), transparent);
}

.guest-card {
    position: relative;
    background: var(--card-bg);
    margin-top: 12px;
    border-radius: var(--radius);
    padding: 20px 20px 20px 16px;
    display: flex;
    align-items: flex-start;
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--border-light);
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;

    &:active {
        transform: scale(0.985);
        box-shadow: var(--shadow-md);
    }
}

.card-accent {
    position: absolute;
    left: 0;
    top: 16px;
    bottom: 16px;
    width: 4px;
    border-radius: 0 3px 3px 0;
    background: linear-gradient(180deg, var(--accent), var(--accent-soft));
}

.guest-photo {
    width: 140px;
    height: 140px;
    margin-right: 16px;
    flex-shrink: 0;

    img {
        width: 140px;
        height: 140px;
        border-radius: 50%;
        object-fit: cover;
        border: 3px solid var(--border);
        box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    }
}

.guest-info {
    flex: 1;
    min-width: 0;

    .guest-cname {
        font-size: 30px;
        font-weight: 700;
        color: var(--ink);
        line-height: 1.4;
        margin-bottom: 4px;
    }

    .guest-cncompany {
        font-size: 26px;
        color: var(--ink-light);
        line-height: 1.4;
        margin-bottom: 8px;
    }

    .guest-cnintroduction {
        position: relative;
        font-size: 26px;
        line-height: 1.6;
        color: var(--ink-muted);
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;

        .detail-link {
            position: absolute;
            right: 0;
            bottom: 0;
            color: var(--accent);
            background: linear-gradient(to right, transparent, var(--card-bg) 30%);
            padding-left: 24px;
            font-size: 24px;
            font-weight: 500;
        }
    }
}

.guset-nav {
    position: absolute;
    top: 0;
    right: 0;
    width: 44px;
    min-height: 100%;
    z-index: 100;
    background: var(--card-bg);
    border-left: 1px solid var(--border-light);
    box-shadow: -2px 0 8px rgba(44, 44, 58, 0.03);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0;

    .letter-t {
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 24px;
        color: var(--ink-muted);
        border-radius: 8px;
        margin: 2px 0;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .letter-t.active {
        background: var(--accent);
        color: #fff;
        font-weight: 700;
        box-shadow: 0 2px 6px rgba(37, 99, 235, 0.3);
    }

    &.fixed {
        position: fixed;
        top: 0;
    }
}

.modal {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(44, 44, 58, 0.6);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    z-index: 1000;
    animation: fadeIn 0.2s ease;

    .details-conss {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 10001;
        width: 100%;
        height: 70%;
        background: var(--card-bg);
        border-radius: 20px 20px 0 0;
        overflow-y: auto;
        box-shadow: 0 -8px 32px rgba(44, 44, 58, 0.15);
        animation: slideUp 0.3s ease;
    }
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideUp {
    from { transform: translateY(20%); }
    to { transform: translateY(0); }
}
</style>
<style type="text/css">
.roomlist .van-popup__close-icon {
    font-size: 50px;
}
</style>
